import Vue from 'vue';
import Vapi from "vuex-rest-api"

const api = new Vapi({
    axios: Vue.axios,
    state: {}
})
    .get({
        action: "getTop",
        property: "top",
        path: 'api.php?method=cabinet&type=getTop'
    })
    .get({
        action: "getStat",
        property: "stat",
        path: 'api.php?method=cabinet&type=getStat'
    })
    .post({
        action: "setEmail",
        property: "setEmailResult",
        path: ({email}) => `api.php?method=cabinet&type=setEmail&email=${email}`
    })
    .post({
        action: "remEmail",
        property: "remEmailResult",
        path: 'api.php?method=cabinet&type=remEmail'
    })
    .post({
        action: "setVk",
        property: "setVkResult",
        path: 'api.php?method=cabinet&type=setVk'
    })
    .post({
        action: "remVk",
        property: "remVkResult",
        path: 'api.php?method=cabinet&type=remVk'
    })
    .post({
        action: "authInVk",
        property: "getVkResult",
        path: 'api.php?method=cabinet&type=getVk'
    })
    .getStore({namespaced: true});

export default {
    ...api,
    getters: {
        getVkInfo: (s) => (vk) => {
            if(vk){
                try {
                    let info = JSON.parse(localStorage.getItem('vkUser'));
                    if(info && info.id == vk) return info;
                }
                catch (e) {};
                return {
                    first_name: `#${vk}`
                };
            }
        }
    },
    mutations: {
        resetStore(s){
            s.top = null;
            s.stat = null;
        },
        ...api.mutations
    },
    actions: {
        authVk(s){
            return new Promise((resolve, reject)=>{
                if(!window.VK) return  reject('Ошибка скрипта VK');
                window.VK.Auth.login(({session, status})=>{
                    if(status === 'connected') {
                        localStorage.setItem('vkUser', JSON.stringify(session.user));
                        resolve(session);
                    }
                    else reject(`Не авторизован (${status})`);
                });
            });
        },
        ...api.actions
    }
};